import PropTypes from 'prop-types';
import { usePathValidation } from './hooks/usePathValidation';

function LocalizedRouter({ children }) {
  usePathValidation();

  return children;
}

LocalizedRouter.propTypes = {
  children: PropTypes.node.isRequired
};

export default LocalizedRouter;
